import React from 'react';
import { getCustomerId } from '../../helpers/AbloyKeyHelper';

const KeyForPerson = ({customers, currentCustomerId, selectCustomer}) => {
  if (customers.length == 0) { return (null) }
  if (!currentCustomerId) { return (null) }

  return (
    <div className={"card-item" + (selectCustomer ? " " : " disabled")}>
      <p>Asiakas</p>
      <select defaultValue={currentCustomerId} onChange={(event)=> selectCustomer(event)} disabled={selectCustomer ? "" : "disabled"}>
        {customers.map(customer => {
          return (
            <option key={'person_'+customer.id} value={customer.id}>
              {customer.first_name + ' ' + customer.last_name}
            </option>
          )
        })}
      </select>
    </div>
  )
};

export default KeyForPerson
